import { render } from "./BaseHeader.vue?vue&type=template&id=33fd09c6"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__